import * as React from "react";

import firebase from "firebase/app";

import { Box, Button, Grid, TextField, Typography } from "@material-ui/core";

import { Page } from "../Page";

export function ForgotPasswordPage(): React.ReactElement {
    const [loading, setLoading] = React.useState(false);

    const [email, setEmail] = React.useState("");
    const [showVerify, setShowVerify] = React.useState(false);

    const [error, setError] = React.useState("");

    const handleEmailChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    };

    const onClick = async () => {
        setLoading(true);

        try {
            await firebase.auth().sendPasswordResetEmail(email);
            setShowVerify(true);
        } catch (error) {
            const e = error as Error;

            setError(e.message);
        }

        setLoading(false);
    };

    return (
        <Page>
            <Box mb={2}>
                <Typography variant="h5">Reset password</Typography>
            </Box>
            
            {!showVerify &&
                <Grid container direction="column" alignItems="center" spacing={2}>
                    <Grid item>
                        <TextField fullWidth value={email} onChange={handleEmailChanged} disabled={loading} label="Email" type="email" autoComplete="email"/>
                    </Grid>
                    <Grid item>
                        <Button onClick={onClick} disabled={loading} variant="contained" color="primary">Reset password</Button>
                    </Grid>
                    {error.length !== 0 &&
                        <Grid item>
                            <Typography color="error">{error}</Typography>
                        </Grid>
                    }
                </Grid>
            }
            {showVerify && 
                <Typography>A password reset e-mail was sent to your e-mail address.</Typography>
            }
        </Page>
    );
}